import { StateCreator } from 'zustand';
import { Coordinate } from 'ol/coordinate';
import { Extent } from 'ol/extent';
import { Feature } from 'ol';
import { LayerDefinition, SystemLayerKey } from '@packages/database/types';

export type SelectionSource = 'map' | 'list' | 'search' | 'url' | 'scroller';

export interface SelectedFeature {
  id: string;
  layerKey: SystemLayerKey | string;
  data: Record<string, unknown>;
  layer?: LayerDefinition;
  feature?: Feature;
  coordinate?: Coordinate;
  geometry?: any;
}

export interface ProjectAreaSelection {
  serviceAreaId: string;
  boundaryExtent: Extent;
  features: any[];
}

export interface SelectionSlice {
  selected: SelectedFeature[];
  activeIndex: number;
  source: SelectionSource | null;
  coordinate: Coordinate | null;
  projectArea: ProjectAreaSelection | null;
  markerLocation: { coordinate: Coordinate; data?: any } | null;

  // Actions
  setSelection: (
    items: SelectedFeature[],
    source?: SelectionSource,
    coord?: Coordinate,
  ) => void;
  setProjectArea: (area: ProjectAreaSelection | null) => void;
  setMarker: (loc: { coordinate: Coordinate; data?: any } | null) => void;
  next: () => void;
  prev: () => void;
  clearSelection: () => void;
}

export const createSelectionSlice: StateCreator<SelectionSlice> = (set) => ({
  selected: [],
  activeIndex: 0,
  source: null,
  coordinate: null,
  projectArea: null,
  markerLocation: null,

  setSelection: (items, source = 'map', coord) =>
    set({
      selected: items,
      activeIndex: 0,
      source,
      coordinate: coord ?? items[0]?.coordinate ?? null,
    }),

  setProjectArea: (area) => set({ projectArea: area }),
  setMarker: (loc) => set({ markerLocation: loc }),

  next: () =>
    set((s) => ({ activeIndex: (s.activeIndex + 1) % s.selected.length })),

  prev: () =>
    set((s) => ({
      activeIndex: (s.activeIndex - 1 + s.selected.length) % s.selected.length,
    })),

  clearSelection: () =>
    set({
      selected: [],
      activeIndex: 0,
      source: null,
      coordinate: null,
      markerLocation: null,
    }),
});
